import { ILocalTrack } from "agora-rtc-react";

export function isTrackSame(track1: ILocalTrack, track2: ILocalTrack) {
  return track1.getTrackId() == track2.getTrackId();
}
